import type { ReactNode } from 'react'
import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import getOfferFeatureIcon from 'lib/offer/getOfferFeatureIcon'
import formatOfferInclusionDescription from 'lib/offer/formatOfferInclusionDescription'
import getInclusionMinStayText from 'lib/offer/getInclusionMinStayText'

interface Props {
  inclusion: App.PackageInclusion
  showMinStayDescription?: boolean
  showMoreLink?: ReactNode
}

function CruiseOfferInclusionItem({ inclusion, showMinStayDescription, showMoreLink }: Props) {
  const intl = useIntl()
  const Icon = useMemo(() => getOfferFeatureIcon(inclusion.symbol), [inclusion.symbol])
  const inclusionDescription = useMemo(() => {
    return formatOfferInclusionDescription(inclusion.description, intl)
  }, [inclusion.description, intl])
  const minStayDescription = showMinStayDescription ? getInclusionMinStayText(inclusion, intl) : undefined

  return <BodyTextBlock
    variant="medium"
    colour={inclusion.isHighlighted ? 'highlight-primary-dark' : undefined}
    weight={inclusion.isHighlighted ? 'bold' : 'normal'}
    startIcon={<Icon
      colour={inclusion.isHighlighted ? 'highlight-primary-dark' : undefined}
      data-symbol={inclusion.symbol}
    />}
  >
    {inclusionDescription} {minStayDescription}
    {!!showMoreLink && <> {showMoreLink}</>}
  </BodyTextBlock>
}

export default CruiseOfferInclusionItem
